import { useQuery } from "@tanstack/react-query"
import { fetchUser } from "api/fetchUser"
import ProfileLayout from "components/Layout/Profile/ProfileLayout"
import AccountTab from "components/page_components/User/Tabs/Account/AccountTab"
import { NextSeo } from "next-seo"
import { motion, AnimatePresence } from "framer-motion"
import UserAvatar from "components/page_components/User/UserAvatar"
import useWindowSize from "hooks/useWindowSize"
import ProfileSkeleton from "components/Skeleton/ProfileSkeleton"
import { useUserContext } from "context/UserContext"
import { useEffect, useState } from "react"

const Account = () => {
    const { isLoading, data } = useQuery({
        queryKey: ["user"],
        queryFn: fetchUser,
    })
    const { isMobile } = useWindowSize()
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        setMounted(true)
    }, [])

    if (!mounted) {
        return (
            <ProfileLayout>
                <ProfileSkeleton type="account" />
            </ProfileLayout>
        )
    }

    return (
        <>
            <NextSeo
                noindex
                nofollow
            />
            <ProfileLayout>
                <AnimatePresence mode="wait">
                    {isLoading ? (
                        <ProfileSkeleton type="account" />
                    ) : (
                        <motion.div
                            key="content"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.25 }}
                        >
                            {isMobile ? null : <UserAvatar />}
                            <AccountTab user={data?.payload} />
                        </motion.div>
                    )}
                </AnimatePresence>
            </ProfileLayout>
        </>
    )
}

export default Account
